import { isEmpty } from 'lodash';

export const invokeMoengageAnalytics = (event, moengageData) => {
  console.log("MOENGAGE::::::::", event, moengageData)
  if (window.Moengage)
    if (!isEmpty(moengageData))
      window.Moengage.track_event(event, moengageData);
    else window.Moengage.track_event(event);
};
